export const PARAMS_KEYS = {
  SHOW_HISTORY: 'showHistory',
  TAB: 'tab',
  PAGE: 'page',
  STATUS: 'status',
};
